import React from 'react'
import NeedsFund from '../NeedsFund'
import DefaultContainer from '../DefaultContainer'
import UkFundReporting from './UkFundReporting'
export default function UkFundReportingWrapper({ fund, fundsClient }) {
    return (<NeedsFund fund={fund}><DefaultContainer style={{ color: 'white' }}>
        <UkFundReporting fund={fund} fundsClient={fundsClient} />
    </DefaultContainer>
    </NeedsFund>
    )

}